import { configureStore } from "@reduxjs/toolkit";

// import { userSlice } from "./API/userSlice";

import isAuthReducer from "./isAuthSlice";
import formReducer from './formSlice';
import businessReducer from './businessSlice'
import { reviewSlice } from './API/ReviewSlice';

import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {userSlice} from "./API/userSlice";
import {companySlice} from "./API/companySlice";
import {fileSlice} from "./API/fileSlice";
import {membersSlice} from "./API/membersSlice";
import {customerSlice} from "./API/customerSlice";
import { crmSlice } from './API/CrmSlice';
import { notificationSlice } from './API/notificationSlice';
import {customerV2Slice} from "./API/customerV2Slice";
import {reviewV2Slice} from "./API/reviewV2Slice";
const formPersistConfig = {
  key: "form",
  version: 1,
  storage, // localStorage
};

const isAuthConfig = {
  key: "isAuth",
  version: 1,
  storage,
};

const businessConfig = {
  key: "isAuth",
  version: 1,
  storage,
};

const persistedFormReducer = persistReducer(formPersistConfig, formReducer);
const persistedIsAuthReducer = persistReducer(isAuthConfig, isAuthReducer);
const persistedBusinessReducer = persistReducer(businessConfig, businessReducer);

export const store = configureStore({
  reducer: {
    [userSlice.reducerPath]: userSlice.reducer,
    [companySlice.reducerPath]: companySlice.reducer,
    [membersSlice.reducerPath]: membersSlice.reducer,
    [fileSlice.reducerPath]: fileSlice.reducer,
    isAuth: persistedIsAuthReducer,
    form: persistedFormReducer,
    business: persistedBusinessReducer,
    [reviewSlice.reducerPath]: reviewSlice.reducer,
    [customerSlice.reducerPath]: customerSlice.reducer,
    [customerV2Slice.reducerPath]: customerV2Slice.reducer,
    [reviewV2Slice.reducerPath]: reviewV2Slice.reducer,
    [crmSlice.reducerPath]: crmSlice.reducer,
    [notificationSlice.reducerPath]: notificationSlice.reducer,  
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] // Ignore these redux-persist actions
      }
    })
      .concat(userSlice.middleware)
      .concat(companySlice.middleware)
      .concat(fileSlice.middleware)
      .concat(membersSlice.middleware)
      .concat(reviewSlice.middleware)
      .concat(customerSlice.middleware)
      .concat(customerV2Slice.middleware)
      .concat(reviewV2Slice.middleware)
      .concat(crmSlice.middleware)
      .concat(notificationSlice.middleware)
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
